import { render } from "./SiteHeader.vue?vue&type=template&id=087b7669&ts=true"
import script from "./SiteHeader.vue?vue&type=script&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__